<template>
  <div class="manageNav scroll">
    <div v-for="(item, index) in list">
      <div class="navItem" :key="item.name" v-if="item.isShow">
        <template v-if="item.meta.displayable">
          <div
            class="navItemTitle"
            @click="navClick(item)"
            :class="{ navItemTitleOn: item.change }"
          >
            <div>
              <el-image :src="item.icon" v-if="item.icon"></el-image>
              <span>{{ item.meta.title }}</span>
            </div>
            <div
              class="sj"
              v-if="item.hasChildren"
              :class="{ on: item.isShowChild }"
            ></div>
          </div>
          <div
            v-if="item.hasChildren"
            class="navMode"
            :style="
              'height: ' +
              (item.isShowChild ? 50 * canShowChild(item.children) : 0) +
              'px'
            "
          >
            <template v-for="(t, i) in item.children">
              <div
                class="navChildrenItem"
                v-show="t.isShow && t.meta.displayable"
              >
                <div
                  class="navChildrenContent"
                  @click="navClick(t)"
                  :class="{ navChildrenContentOn: t.change }"
                >
                  <span>{{ t.meta.title }}</span>
                  <!-- <Arrow-right class="children"></Arrow-right> -->
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import navs from "../router/router.js";
navs = JSON.parse(JSON.stringify(navs));
import { common } from "../request/api.js";
import pfn from "@/utils/publicFn";
const isGroupval = pfn.isGroup()

export default {
  name: "mclz",
  data() {
    return {
      list: [],
      isGroupval
    };
  },
  created: function () {
    if (this.$store.state.token) {
      this.initNav();
    }
  },
  watch: {
    $route(newVal, oldVal) {
      this.setNav();
      if (this.$store.state.token && this.$store.state.authList.length == 0) {
        this.$nextTick(() => {
          this.initNav();
        });
      }
    },
  },
  methods: {
    testAuth() {
      return true;
    },
    initNav() {
      //   this.$request.common.getAdminUserInfoByToken().then((res) => {
      //     if (res && res.data.code == 200) {
      //       this.$store.commit("setUserInfo", res.data.content.data);
      //       let menuList = this.$store.state.userInfo.menu_list;
      //       menuList.sort((a, b) => a.menu_id - b.menu_id);
      //       let list = [];
      //       menuList.forEach((t) => {
      //         if (t.file_path) {
      //           let obj = navs.find((item) => item.name == t.file_path);
      //           if (!!obj) {
      //             list.push(obj);
      //           } else {
      //             let pushObj = {};
      //             for (let i in navs) {
      //               if (navs[i].children?.length > 0) {
      //                 obj = navs[i].children.find(
      //                   (item) => item.name == t.file_path
      //                 );
      //                 if (obj) {
      //                   let canHas = list.find(
      //                     (item) => item.name == navs[i].name
      //                   );
      //                   if (canHas) {
      //                     canHas.children.push(obj);
      //                   } else {
      //                     pushObj = JSON.parse(JSON.stringify(navs[i]));
      //                     delete pushObj.children;
      //                     pushObj.children = [obj];
      //                     list.push(pushObj);
      //                   }
      //                   break;
      //                 }
      //               }
      //             }
      //           }
      //         }
      //       });

      //       this.list = list.map((item) => {
      //         item.isShowChild = false;
      //         item.change = false;
      //         if (item.children) {
      //           item.children.forEach((t) => {
      //             t.isShow = this.testAuth(t.name);
      //           });
      //         }
      //         item.isShow = this.testAuth(item.name);
      //         return item;
      //       });

      this.list = [
        {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "首页",
          },

          name: "home",
          path: "/home",
        },
        {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "课程管理",
          },

          name: "class",
          path: "/class",
        },
        {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "学员管理",
          },

          name: "meet",
          path: "/meet",
        },
        {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "报名管理",
          },
          children: [
             {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "报名课程管理",
          },

          name: "baoming",
          path: "/baoming",
        },
             {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "报名学员管理",
          },

          name: "baominguser",
          path: "/baominguser",
        },
        ],

              name: "baoming",
          name: "baoming",
          path: "/baoming",
        },
      ];
      if (this.isGroupval) {
        this.list.push(
        {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "单位管理",
          },

          name: "activity",
          path: "/activity",
        },
        {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "主题管理",
          },

          name: "zuti",
          path: "/zuti",
        },
      {
          canShow: true,
          change: true,
          isShow: true,
          isShowChild: false,
          meta: {
            displayable: true,
            isUseCache: false,
            keepAlive: true,
            title: "公告管理",
          },

          name: "gonggao",
          path: "/gonggao",
        },)
      }
      this.setNav();
      //     }
      //   });
    },
    canShowChild(list) {
      let num = 0;
      for (let i in list) {
        if (list[i].meta?.displayable && list[i].isShow) {
          num++;
        }
      }
      return num;
    },
    setNav() {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].change = false;
        this.list[i].canShow = this.list[i].meta.displayable;
        if (this.list[i].children) {
          for (let k = 0; k < this.list[i].children.length; k++) {
            if (this.list[i].children[k].meta.displayable) {
              this.list[i].hasChildren = true;
            }
            this.list[i].children[k].change = false;
            for (let j = 0; j < this.$route.matched.length; j++) {
              if (
                this.$route.matched[j].name == this.list[i].children[k].name
              ) {
                this.list[i].children[k].change = true;
                this.list[i].isShowChild = true;
              }
            }
          }
        }
        for (let j = 0; j < this.$route.matched.length; j++) {
          if (
            this.$route.matched[j].name == this.list[i].name ||
            this.$route.matched[j].meta?.pName == this.list[i].name
          ) {
            this.list[i].change = true;
          }
          if (this.list[i].children && this.list[i].children.length > 0) {
            for (let k = 0; k < this.list[i].children.length; k++) {
              if (
                this.$route.matched[j].name == this.list[i].children[k].name ||
                this.$route.matched[j].meta?.pName ==
                  this.list[i].children[k].name
              ) {
                this.list[i].children[k].change = true;
              }
            }
          }
        }
      }
    },
    navClick(e) {
      if (e.hasChildren) {
        e.isShowChild = !e.isShowChild;
      } else {
        if (e.path != this.$route.path) {
          this.$store.commit("$navTo", e.path);
        }
      }
    },
  },
};
</script>
<style>
.navItemTitleOn .el-image {
  overflow: hidden;
  width: 15px;
}

.navItemTitle:hover .el-image img,
.navItemTitleOn .el-image img {
  filter: drop-shadow(0px 150px 0px #fff);
  transform: translateY(-150px);
  width: 15px;
}
</style>
<style scoped lang="scss">
.el-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.manageNav {
  width: 100%;
  padding: 0 0 80px;
  user-select: none;
  overflow-y: scroll;
  background: #fff;
  height: calc(100vh - 80px) !important;
  &::-webkit-scrollbar {
    width: 0;
    background-color: var(--el-color-primary);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }

  .navItem {
    .navItemTitle {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      padding: 12px 12px 12px 20px;
      border-top: 1px solid #f3f3f3;
      .el-image {
        width: 14px;
      }

      svg {
        color: #666;
      }

      transition: all 0.2s;

      .sj {
        width: 0;
        height: 0;
        border: 5px solid;
        border-color: var(--el-color-primary) transparent transparent;
        border-radius: 2px;
        transform: translateY(2px);
        &.on {
          transform: translateY(-2px) rotateZ(180deg);
        }
      }
      &.navItemTitleOn {
        background: var(--el-color-primary);
        border-top: 1px solid var(--el-color-primary);
        color: #fff;

        .sj {
          transform: translateY(-2px) rotateZ(180deg);
          border-color: #fff transparent transparent;
        }
        > div {
          span,
          svg {
            color: #fff;
          }
        }
      }

      .children {
        transition: transform 0.2s;

        &.childrenShow {
          transform: rotateZ(90deg);
        }

        &.childrenHide {
          transform: rotateZ(0);
        }
      }

      &:hover {
        background: var(--el-color-primary-dark-2);
        cursor: pointer;
        color: #333;
        border-top: 1px solid var(--el-color-primary-dark-2);
        .sj {
          border-color: #fff transparent transparent;
        }
        > div {
          span,
          svg {
            color: #fff;
          }
        }
      }

      > div {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        span {
          font-size: 15px;
          color: #333;
          margin-left: 8px;
        }
      }

      svg {
        width: 16px;
      }
    }

    .navMode {
      overflow: hidden;
      transition: height 0.2s;

      .navChildrenItem {
        width: 100%;
        height: 50px;
        border-top: 1px solid #f3f3f3;
        .navChildrenContent {
          cursor: pointer;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 0 12px 0 42px;

          svg {
            width: 16px;
          }

          &:hover {
            background: var(--el-color-primary-light-8);
          }

          &:active {
            background: var(--el-color-primary-light-6);
          }
        }

        .navChildrenContentOn {
          color: #333;
          background: var(--el-color-primary-light-9);
        }
      }
    }
  }
}
@media screen and (max-width: 980px) {
  .manageNav {
    overflow-y: unset;
  }
  .sj {
    display: none !important;
  }
  .navItem {
    position: relative;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      .navMode {
        transform: scale(1, 1) !important;
      }
    }
    .navItemTitle {
      width: 100%;
      height: 50px !important;
      text-align: left;
      span {
        white-space: nowrap;
      }
    }
    .navMode {
      position: absolute;
      z-index: 999;
      left: 100%;
      // top: 0;
      width: 120px;
      border-radius: 5px;
      height: auto !important;
      transform: scale(0, 0);
      transition: all 0.2s;
      background: #fff;
      box-shadow: 0 0 10px 0 rgba(156, 156, 156, 0.2);
      .navChildrenItem {
        .navChildrenContent {
          padding: 0 !important;
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
        }
      }
    }
  }
}
</style>
